<template>
  <v-dialog v-model="isOpen" max-width="650" scrollable persistent style="z-index: 999999;">
    <v-card>
      <v-card-title class="dialog-title">
        <span>{{ this.dialogTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-container class="dialog-container mt-5">
          <v-row>
          

             <div class="email-container">
        <img :src="this.computedHeaderSrc" alt="Senso Learn Header" class="header-image">
        
        <div class="content" v-html="this.dialogData">
        </div>
        
        <img :src="this.computedFooterSrc" alt="Senso Learn Footer Illustration" class="footer-image">
    </div>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="btn-section">
        <v-btn class="mr-1 mb-2 add-course-button" color="primary" outlined @click="closeDialog">Close</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    dialogTitle: {
      type: String,
      required: true
    },
    dialogData: {
      type: String,
      default: ''
    },
    headerImgSrc: {
      type: String,
      default: ''
    },
    footerImgSrc: {
      type: String,
      default: ''
    }
  },
  computed: {
    computedHeaderSrc() {
      return this.headerImgSrc != '' ?  this.headerImgSrc : this.$globalConfig.APP_NAME == 'senso' ? "https://learn.senso.cloud/static/login-logo.png" : "https://app.improve.online/static/logo.png";
    },
    computedFooterSrc() {
      return this.footerImgSrc != '' ? this.footerImgSrc : this.$globalConfig.APP_NAME == 'senso' ? "https://senso-learn-public.s3.eu-west-2.amazonaws.com/images/senso-learn-email-footer.png" : "https://improve-public.s3.eu-west-2.amazonaws.com/images/improve-email-footer.png";
    }
  },
  methods: {
    closeDialog() {
      this.$emit('close');
    }
  }
};
</script>
<style scoped>
.email-container {
            max-width: 600px;
            margin: 0 auto;
            background-color: white;
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
            /* padding: 32px */
        }
        
        .header-image {
            width: 200px;
            height: auto;
            display: block;
            margin: 0 auto;
        }
        
        .content {
            padding: 30px 40px;
            color: #2c3e50;
            font-size: 16px;
        }
        
        .greeting {
            margin-bottom: 20px;
            font-weight: 500;
        }
        
        .main-message {
            margin-bottom: 30px;
            font-weight: 500;
        }
        
        .info-section {
            margin-bottom: 20px;
        }
        
        .company-names {
            margin-bottom: 25px;
        }
        
        .closing {
            margin-top: 30px;
            margin-bottom: 0;
            font-weight: 500;
        }
        
        .footer-image {
            width: 100%;
            height: auto;
            max-height: 200px;
            display: block;
        }
        
        @media (max-width: 640px) {
            .email-container {
                margin: 10px;
                border-radius: 8px;
            }
            
            .content {
                padding: 20px 25px;
                font-size: 14px;
            }
        }
</style>